<template>
  <v-card class="card pa-6 mx-auto" elevation="1">
    <div>
      <h2>
        Você confirma geração da etiqueta no melhor envio
      </h2>

      <h3 class="my-5">
        Certifique-se que o status selecionado está correto, ao alterar o mesmo não poderá ser desfeito.
      </h3>
    </div>

    <v-form ref="firstForm" class="pa-0">
      <v-col cols="12" sm="12" md="12" lg="12" class="pa-0">
        <label class="text-left">
          Insira a chave da NF
        </label>
        <v-text-field
            v-mask="['############################################']"
            class="pa-0"
            outlined
            placeholder="Chave da NF"
            v-model="electronicInvoiceKey"
            :rules="[rules.required, rules.min, rules.validateInvoiceKey]"
        >
        </v-text-field>
      </v-col>
    </v-form>

    <v-row class="" cols="12">
      <v-col cols="12" class="d-flex justify-space-between">
        <v-btn outlined width="50%" class="cancelBtn mr-2" @click="close" :loading="loading">
          <span class="cancel">Cancelar</span>
        </v-btn>

        <v-btn width="50%" class="okBtn mr-2" @click="action()" :loading="loading">
          <span class="yep">Confirmar</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.input-modal {
  background: #f5f5f5 !important;
  border: 2px solid #b9b9b9 !important;
  border-radius: 16px !important;
}

.yep {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;

  color: #ffffff;
}

.cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;

  color: #2d3038;
}

.card {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}

.cancelBtn {
  height: 50px !important;

  border: 2px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 6px;
}

.okBtn {
  height: 50px !important;

  background: #2d3038 !important;
  border-radius: 6px;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/ValidateInvoiceKey";

export default {
  name: "GenerateTagModal",

  props: {
    order: Object,
  },

  data: () => ({
    loading: false,
    apiService: new ApiService(),
    electronicInvoiceKey: null,
    rules: {
      required: (value) => !!value || "Campo requerido.",
      min: (v) => (v && v.length >= 44) || "Minimo de 44 caracteres.",
      validateInvoiceKey: (value) => (Utils.INVOICE_KEY(value)) || 'chave da NF inválida.',
    }
  }),

  async created() {
    this.electronicInvoiceKey = null
  },

  methods: {
    close() {
      this.$emit("close");
    },

    action() {
      if (!this.$refs.firstForm.validate()) {
        return;
      }
      this.$emit("action", {electronicInvoiceKey: this.electronicInvoiceKey});
    },
  },
};
</script>
